<template>
  <div>
    <table class="table table-striped table-bordered table-hover">
      <thead>
        <tr>
          <th>Nome</th>
          <th>Sexo</th>
          <th>Idade</th>
          <th>Telefone</th>
          <th>Email</th>
          <th>Indicação</th>
          <th>Convênio</th>
          <th>Procedimento</th>
          <th>Especialidade</th>
          <th>Unidade</th>
          <th>Profissional</th>
          <th>CID</th>
        </tr>
      </thead>
      <tbody>
        <tr v-for="linha in linhas" :key="linha.index">
          <td>{{ linha.paciente.nome }}</td>
          <td>{{ linha.paciente.sexo }}</td>
          <td>{{ linha.paciente.idade }}</td>
          <td>{{ linha.paciente.telefone }}</td>
          <td>{{ linha.paciente.email }}</td>
          <td>{{ linha.paciente.indicacao.valor }}</td>
          <td
            >{{ linha.paciente.convenio.nome }} -
            {{ linha.paciente.convenio.plano }}</td
          >
          <td>{{ linha.procedimento }}</td>
          <td>{{ linha.especialidade }}</td>
          <td>{{ linha.unidade }}</td>
          <td>{{ linha.profissional.nome }}</td>
          <td>{{ linha.cid }}</td>
        </tr>
      </tbody>
    </table>
  </div>
</template>

<script>
export default {
  name: 'LevantamentoMarketingTabela',
  props: {
    linhas: {
      type: Array,
      required: true,
    },
  },
}
</script>
